import assign from '@ali/xutil/assign';
import each from '@ali/xutil/each';
import LiteMap from '@ali/xutil/map-lite';
import isFunction from 'lodash/isFunction';

/**
 * 整个请求生命周期中的上下文，用于保留各种状态，并实现 core/middleware/plugin 的数据共享
 */
export default class Context {

  id = '';                      // context 全局唯一 id
  api = {                       // 接口信息
    type: '',                   // 接口类型
    alias: '',                  // 接口别名，用途：业务打点
    uri: '',                    // 接口标识符
    routes: [],                 // 接口寻址路径，用途：发起真正的接口请求
  };
  middleware = {                // 当前正在执行的中间件的信息
    index: 0,                   // 当前中间件的序号
    fn: undefined,              // [暂未使用] 当前正在执行的中间件函数
  };
  state = new LiteMap();        // [暂未使用] 上下文数据，用途：在 middleware 间传递数据
  error = null;                 // 接口请求错误 如：{code: '', msg: ''}
  rawReq = null;                // 未经处理的原始请求
  rawRes = null;                // 未经处理的原始响应
  request = {                   // 接口请求
    method: 'GET',              // [部分使用] 接口请求方法，同 http method
    headers: {                  // [暂未使用] 接口请求头，同 http request headers
      // 'Content-Type': '',
    },
    query: {},                  // 接口请求入参，主要为业务入参
    body: null,                 // [暂未使用] 接口请求体
    timeout: false,             // `Number` 超时时间 ms： false 或 0 表示不超时
    settings: {                 // 接口请求设置
      // crossOrigin: true,
      // withCredentials: true,
      // jsonpCallback: 'xxx',
    },
  };
  response = {                  // 接口响应
    headers: {},                // [暂未使用] 接口响应头，同 http response headers
    body: null,                 // 接口响应体
  };
  callback = {
    // success   () {},         // 成功回调函数
    // error     () {},         // 失败回调函数
    // notify    () {},         // 通知回调函数
    // beforeXXX () {},         // 前置钩子函数
    // afterXXX  () {},         // 后置钩子函数
  };

  __X__ = null;                  // Core 引用

  constructor(options) {
    let {request, callback} = this;
    this.__X__ = options.__X__;
    this.rawReq = options;
    this.api = options.api;
    request.method   = options.method || 'GET';
    request.headers  = options.headers || null;
    request.query    = options.query;
    request.timeout  = options.timeout || false;
    request.settings = options.settings;
    callback.success = options.success;
    callback.error   = options.error;
    callback.notify  = options.notify ;
  }

  /**
   * Get state by key or get state only for current middleware.
   * @param  {Numner|String} optional key
   * @return {Object}
   */
  getState(key) {
    let {state} = this;
    if (typeof key === 'undefined') {
      key = this.middleware.fn;
    }
    let value = state.get(key);
    if (!value) {
      value = {};
      state.set(key, value);
    }
    return value;
  }

  // emit(ev, ...args) {
  //   this.__X__.emit(ev, ...args);
  // }

  destroy() {
    for (let key in this) {
      if (!this.hasOwnProperty(key)) continue;
      delete this[key];
    }
  }
}



// WEBPACK FOOTER //
// ../x/packages/core/src/context.js